import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderTransferResultImplEncoder } from "../../encoder/OrderTransferResultImplEncoder";

import * as CubiqTS from "../../index";
import { OrderTransferResult } from "../OrderTransferResult";

export class OrderTransferResultImpl extends ConcreteEncodable implements OrderTransferResult {
  public static enType: string = "com.bcdfx.service.OrderTransferResultImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public success: boolean;
  /*FID=3*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderTransferResultImplEncoder.Instance;
    this.setEncodableType(OrderTransferResultImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderTransferResultImpl[" +
      "orderId=" +
      this.orderId +
      "success=" +
      this.success +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
